import { TableColumn } from '@backstage/core-components';
import { CatalogTable, CatalogTableRow } from '@backstage/plugin-catalog';
import { EntityListContextProps } from '@backstage/plugin-catalog-react';

export const genCatalogTableColumns = (
  ctx: EntityListContextProps,
): TableColumn<CatalogTableRow>[] => {
  // Use the new API: CatalogTable.columns to access column factories
  const {
    createNameColumn,
    createSystemColumn,
    createSpecTypeColumn,
    createOwnerColumn,
  } = CatalogTable.columns;

  const newColumns = [
    createNameColumn({ defaultKind: ctx.filters.kind?.value }),
    createSystemColumn(),
    createSpecTypeColumn(),
    createOwnerColumn(),
  ].filter(Boolean) as TableColumn<CatalogTableRow>[];

  // Apply custom width styling
  return newColumns.map(c => ({
    ...c,
    width: 'auto',
  }));
};
